import { useEffect, useRef } from 'react';
import { decodeJWT } from '../utils/decodeJWT';

export function useSessionTimeout(token, onTimeout, idleLimitMs = 15 * 60 * 1000) {
  const idleTimer = useRef(null);
  const activityEvents = ['mousemove', 'keydown', 'click', 'scroll'];

  useEffect(() => {
    if (!token) return;

    const payload = decodeJWT(token);
    if (!payload?.exp) return;

    const expiryMs = payload.exp * 1000 - Date.now();
    if (expiryMs <= 0) {
      onTimeout('jwt');
      return;
    }

    const expiryTimeout = setTimeout(() => {
      onTimeout('jwt');
    }, expiryMs);

    const resetIdle = () => {
      clearTimeout(idleTimer.current);
      idleTimer.current = setTimeout(() => {
        onTimeout('idle');
      }, idleLimitMs);
    };

    activityEvents.forEach(evt => window.addEventListener(evt, resetIdle));
    resetIdle();

    return () => {
      clearTimeout(expiryTimeout);
      clearTimeout(idleTimer.current);
      activityEvents.forEach(evt => window.removeEventListener(evt, resetIdle));
    };
  }, [token, onTimeout, idleLimitMs]);
}